import { render } from "./AboutTimeline.vue?vue&type=template&id=15bb3caa&scoped=true"
import script from "./AboutTimeline.vue?vue&type=script&lang=js"
export * from "./AboutTimeline.vue?vue&type=script&lang=js"

import "./AboutTimeline.vue?vue&type=style&index=0&id=15bb3caa&scoped=true&lang=css"

import exportComponent from "C:\\Users\\sthem\\source\\repos\\Insync\\Pamodzi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15bb3caa"]])

export default __exports__